const COLORS_MAP = {
  Primary: {
    value: "--color-primary",
    label: "primary",
  },
  Yellow: {
    value: "--color-yellow",
    label: "yellow",
  },
  Teal: {
    value: "--color-teal",
    label: "teal",
  },
  Orange: {
    value: "--color-orange",
    label: "orange",
  },
  Lavendar: {
    value: "--color-lavender",
    label: "lavender",
  },
  SkyBlue: {
    value: "--color-sky-blue",
    label: "sky blue",
  },
  Mint: {
    value: "--color-mint",
    label: "mint",
  },
  LightBlue: {
    value: "--color-light-blue",
    label: "sky blue",
  },
  CoolGrey: {
    value: "--color-cool-grey",
    label: "cool grey",
  },
  SlateGrey: {
    value: "--color-slate-grey",
    label: "slate grey",
  },
} as const satisfies OptionsMap

export type Color = ExtractValue<typeof COLORS_MAP>

const _options = buildOptionsFromMap(COLORS_MAP)

export const useColorOptions = () => ({
  options: _options,
  getLabelForValue: (value: Color) =>
    computed(
      () =>
        _options.find((option) => option.value === value)
          ?.label || ""
    ),
})
